var render = function render(){var _vm=this,_c=_vm._self._c;return _c('node',{attrs:{"title":_vm.config.name,"is-root":true,"content":_vm.content,"placeholder":"所有人","header-bgc":"#576a95","header-icon":"el-icon-user-solid"},on:{"selected":function($event){return _vm.$emit('selected')},"insertNode":type => _vm.$emit('insertNode', type)}})
}
var staticRenderFns = []

export { render, staticRenderFns }